/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrIconModule } from "../../icon/icon.module";
import { ClrFormsModule } from "../../forms/forms.module";
import { FormsModule } from "@angular/forms";
import { TREE_VIEW_DIRECTIVES } from "./index";
var ClrTreeViewModule = (function () {
    function ClrTreeViewModule() {
    }
    return ClrTreeViewModule;
}());
export { ClrTreeViewModule };
ClrTreeViewModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ClrFormsModule,
                    ClrIconModule,
                ],
                declarations: [
                    TREE_VIEW_DIRECTIVES
                ],
                exports: [
                    TREE_VIEW_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrTreeViewModule.ctorParameters = function () { return []; };
//# sourceMappingURL=tree-view.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/tree-view/tree-view.module.js
// module id = 179
// module chunks = 4